import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=eaf4f728&scoped=true&"
import script from "./IconDelete.vue?vue&type=script&lang=js&"
export * from "./IconDelete.vue?vue&type=script&lang=js&"
import style0 from "./IconDelete.vue?vue&type=style&index=0&id=eaf4f728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf4f728",
  null
  
)

export default component.exports